/*eslint-disable*/
import api from '../'

class TicketApi {
    // POST: ticket
    static create (ticket) {
        return api.axios.post('/support', ticket)
            .then(response => response.data.ticket);
    }

    // GET: ticket
    static list(params, cancelToken = null) {
        return api.axios.get('/support', { params, cancelToken })
            .then(response => response.data);
    }

    static update(id, params) {
        return api.axios.put('/support/' + id, params)
            .then(response => response.data.ticket);
    }


    static updateSome(params) {
        return api.axios.put('/support', params)
            .then(response => response.data);
    }

    static delete(id, params) {
        return api.axios.delete('/support/' + id, {params})
            .then(response => response.data)
    }

    // GET: ticket/:id
    static show(id) {
        return api.axios.get('/support/' + id)
            .then(response => response.data.ticket)
    }
}

export default TicketApi;
